import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as colors from '@material-ui/core/colors';
import type { AppThunk } from 'src/store';
import { protectedAxios as axios } from 'src/utils/auth';
import { urls } from 'src/utils/api';
import type { PackageType } from 'src/types/PackageType';

export interface AppState {
  isAppReady: boolean;
  packageTypesDict: PackageType[];
}

const initialState: AppState = {
  isAppReady: true,
  packageTypesDict: [],
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAppReady(
      state: AppState,
      action: PayloadAction<boolean>
    ) {
      state.isAppReady = action.payload;
    },
    setPackageTypesDict(
      state: AppState,
      action: PayloadAction<PackageType[]>
    ) {
      state.packageTypesDict = action.payload;
    },
    bindColorsToPackages(
      state: AppState
    ) {
      const { packageTypesDict } = state;

      const materialColors = Object.entries(colors)
        .filter(([color]) => color !== 'common')
        .sort();

      const colorsCount = materialColors.length;

      const coloredDict = packageTypesDict.map((packageType, packageIdx) => {
        const colorIdx = packageIdx >= colorsCount ? packageIdx % colorsCount : packageIdx;
        const bgColor: string = materialColors[colorIdx][1][50] ?? '#F4F6F8';
        const textColor: string = materialColors[colorIdx][1][800] ?? colors.blueGrey[900];

        return {
          ...packageType,
          bgColor,
          textColor
        };
      });

      state.packageTypesDict = coloredDict;
    }
  }
});

export const fetchPackageTypesDict = (): AppThunk => async (dispatch) => {
  const {
    actions: {
      setPackageTypesDict,
      bindColorsToPackages,
      setAppReady
    }
  } = slice;

  try {
    setAppReady(false);

    const { data } = await axios.get<PackageType[]>(urls.batchPackageTypes);

    dispatch(setPackageTypesDict(data));
    dispatch(bindColorsToPackages());
  } catch (e) {
    console.warn('Не удалось получить справочник упаковок');
  }

  dispatch(setAppReady(true));
};

export const { setAppReady } = slice.actions;

export const { reducer } = slice;

export default slice;
